import React from "react";

import { LoadState } from "@/lib/scan-ui/screen";
import { OrgWhitelistCard } from "@/pages/settings/cards/OrgWhitelistCard";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { useSystemSettingsQuery } from "@/pages/settings/useSystemSettingsQuery";

/** Настройки проверки перемещений: пока только фильтр организаций. */
export function TransferCheckSettingsPage(): React.ReactElement {
  const { data, isLoading, error, refetch } = useSystemSettingsQuery();

  if (isLoading || error || !data) {
    return (
      <div className="mx-auto max-w-2xl space-y-6">
        <SettingsPageHeader
          title="Перемещения"
          subtitle="Организации в фильтре «Проверка перемещений»."
        />
        <LoadState
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
          className="flex flex-col items-center gap-3 p-4 text-center"
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <SettingsPageHeader
        title="Перемещения"
        subtitle="Организации в фильтре «Проверка перемещений»."
      />
      <OrgWhitelistCard
        title="Организации в фильтре «Проверка перемещений»"
        field="transfer_check_org_refs"
        current={data.transfer_check_org_refs}
      />
    </div>
  );
}
